var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.maxPoints > 0
    ? _c("div", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$translate("BonusProgram::Template.reachablePoints", {
              maxPoints: _vm.maxPoints,
            })
          ),
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }